(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    const target = document.querySelector('[data-mw-news-success], #MwNewsletterError');
    if (!target) return;
    // Shopify redirecter til #MwNewsletter efter post — fokusér kvittering/fejl
    if (window.location.hash === '#MwNewsletter' || document.querySelector('#MwNewsletterError')) {
      (target.matches('[tabindex]') ? target : document.getElementById('MwNewsletterEmail') || target).focus({ preventScroll: false });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const HIDE_AFTER = 120;

    const initOverlay = (header, sig) => {
      const wrap = header.closest('.shopify-section');
      if (!wrap) return;
      if (header.dataset.transparent !== 'true') return;
      // Sidens første sektion ligger i <main> (skip-link/landmark, MW-007)
      const main = document.getElementById('MainContent');
      let n = main ? main.querySelector(':scope > .shopify-section') : null;
      if (!n) {
        n = wrap.nextElementSibling;
        while (n && !(n.classList && n.classList.contains('shopify-section'))) n = n.nextElementSibling;
      }
      const hero = n ? n.querySelector('.mw-hero') : null;
      if (!hero) return;
      wrap.classList.add('mw-header-overlay');
      const setTone = (tone) => wrap.classList.toggle('mw-header-overlay--ink', tone === 'ink');
      setTone(hero.classList.contains('mw-hero--ink') ? 'ink' : 'bone');
      // Slideren skifter tone pr. slide — følg den (MW-004)
      n.addEventListener('mw:hero:change', (e) => setTone(e.detail && e.detail.tone), sig);
    };

    // Mega-nav: hover med intent-forsinkelse på fin pointer, klik/Enter for
    // tastatur og touch. Panelerne er ægte DOM — ingen JS-only-indhold.
    const initMegaNav = (header, sig) => {
      const nav = header.querySelector('[data-mw-meganav]');
      if (!nav) return;
      const items = Array.from(nav.querySelectorAll('[data-mw-nav-item]'));
      if (!items.length) return;
      const fine = window.matchMedia('(hover: hover) and (pointer: fine)');
      let openItem = null;
      let hoverTimer = 0;

      const setOpen = (item, open) => {
        const btn = item.querySelector('[data-mw-nav-trigger]');
        const panel = item.querySelector('[data-mw-nav-panel]');
        if (!btn || !panel) return;
        // To paneler må aldrig stå åbne samtidig: utility-barens disclosure lukkes
        if (open) document.querySelectorAll('details[data-mw-annc][open]').forEach((el) => { el.open = false; });
        panel.hidden = !open;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        openItem = open ? item : openItem === item ? null : openItem;
        header.classList.toggle('has-open-nav', !!openItem);
        // Panel åbent over hero → headeren bliver solid (ellers: foto + transparent header + lyst panel)
        if (openItem) header.classList.add('is-solid');
        else if (window.scrollY <= 8) header.classList.remove('is-solid');
      };

      const closeAll = () => {
        items.forEach((i) => setOpen(i, false));
        openItem = null;
        header.classList.remove('has-open-nav');
      };

      items.forEach((item) => {
        const btn = item.querySelector('[data-mw-nav-trigger]');
        if (!btn) return;

        btn.addEventListener('click', () => {
          const isOpen = btn.getAttribute('aria-expanded') === 'true';
          closeAll();
          if (!isOpen) setOpen(item, true);
        }, sig);

        item.addEventListener('pointerenter', (e) => {
          if (e.pointerType !== 'mouse' || !fine.matches) return;
          clearTimeout(hoverTimer);
          hoverTimer = setTimeout(() => {
            closeAll();
            setOpen(item, true);
          }, 100);
        }, sig);

        item.addEventListener('pointerleave', (e) => {
          if (e.pointerType !== 'mouse' || !fine.matches) return;
          clearTimeout(hoverTimer);
          hoverTimer = setTimeout(closeAll, 160);
        }, sig);
      });

      nav.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape' || !openItem) return;
        const btn = openItem.querySelector('[data-mw-nav-trigger]');
        closeAll();
        if (btn) btn.focus();
      }, sig);

      // Fokus ud af navigationen (tab videre) lukker panelet
      nav.addEventListener('focusout', (e) => {
        if (nav.contains(e.relatedTarget)) return;
        closeAll();
      }, sig);

      document.addEventListener('click', (e) => {
        if (!nav.contains(e.target) && openItem) closeAll();
      }, sig);
      sig.signal.addEventListener('abort', () => clearTimeout(hoverTimer));
    };

    // Skjul-ved-scroll-ned / vis-ved-scroll-op. Headeren viger for indholdet,
    // men er ét swipe væk. Aldrig skjult mens en menu er åben.
    const initScroll = (header, sig) => {
      let last = window.scrollY;
      let ticking = false;

      const mode = header.dataset.sticky || 'hide';
      const wrap = header.closest('.shopify-section');
      if (mode === 'none' && wrap) wrap.classList.add('is-static');
      const update = () => {
        ticking = false;
        const y = window.scrollY;
        header.classList.toggle('is-solid', y > 32);
        if (mode !== 'hide') { header.classList.remove('is-hidden'); last = y; return; }
        if (header.classList.contains('has-open-nav')) {
          header.classList.remove('is-hidden');
          last = y;
          return;
        }
        const delta = y - last;
        if (Math.abs(delta) > 6) {
          header.classList.toggle('is-hidden', delta > 0 && y > HIDE_AFTER);
          last = y;
        }
      };

      update();
      window.addEventListener(
        'scroll',
        () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(update);
        },
        { passive: true, signal: sig.signal }
      );
    };

    // Lifecycle (MW-016): én controller pr. header-instans; alle document/
    // window-lyttere bindes til en AbortController, som afbrydes ved Theme
    // Editor-unload eller når headeren erstattes — ingen ophobning.
    const controllers = new WeakMap();

    const teardown = (header) => {
      const ac = controllers.get(header);
      if (ac) ac.abort();
      controllers.delete(header);
    };

    const init = () => {
      document.querySelectorAll('[data-mw-header]').forEach((header) => {
        if (controllers.has(header)) return;
        const ac = new AbortController();
        controllers.set(header, ac);
        const sig = { signal: ac.signal };
        initOverlay(header, sig);
        initMegaNav(header, sig);
        initScroll(header, sig);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:unload', (e) => {
      if (!e.target || !e.target.querySelectorAll) return;
      e.target.querySelectorAll('[data-mw-header]').forEach(teardown);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mw-announcement"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__mwAnnc) return;
    window.__mwAnnc = true;

    const details = () => document.querySelector('details[data-mw-annc]');
    const close = () => { const d = details(); if (d && d.open) d.open = false; };

    // Scroll-låsen (<details scroll-lock>) stopper brugerens egen scroll, men ikke
    // programmatisk scroll — fx når browseren bringer et fokuseret element i syne.
    // Sker det, glider panelet op med baren, mens scrimmen bliver hængende fixed og
    // mørklægger siden uden synlig grund. Tærsklen på 4 px undgår at små justeringer
    // lukker panelet, mens en reel scroll rydder tilstanden op.
    let åbnetVedY = 0;
    document.addEventListener('toggle', (e) => {
      if (e.target instanceof HTMLElement && e.target.matches('details[data-mw-annc]') && e.target.open) {
        åbnetVedY = window.scrollY;
      }
    }, true);
    window.addEventListener('scroll', () => {
      const d = details();
      if (d && d.open && Math.abs(window.scrollY - åbnetVedY) > 4) close();
    }, { passive: true });

    document.addEventListener('click', (e) => {
      const d = details();
      if (!d || !d.open) return;
      // Luk-knappen i bunden af panelet: samme udgang som Escape, med fokusretur.
      if (e.target.closest('[data-mw-annc-close]')) {
        close();
        d.querySelector('summary')?.focus();
        return;
      }
      if (!d.contains(e.target)) close();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      // Escape må kun ramme os, hvis ingen anden dialog er åben — ellers lukker
      // et Escape rettet mod søgning eller kurv også dette panel.
      if (document.querySelector('dialog[open]')) return;
      const d = details();
      if (!d || !d.open) return;
      close();
      d.querySelector('summary')?.focus();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mw-breath"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('mw-breath')) return;

    class MwBreath extends HTMLElement {
      #timer = null;
      #nedtaeller = null;
      #koerer = false;

      connectedCallback() {
        this.knap = this.querySelector('[data-mw-breath-go]');
        this.faseEl = this.querySelector('[data-mw-breath-fase]');
        this.talEl = this.querySelector('[data-mw-breath-tal]');
        this.liveEl = this.querySelector('[data-mw-breath-live]');
        if (!this.knap) return;

        this.faser = [
          { id: 'ind', sek: Number(this.dataset.ind) || 0, etiket: this.dataset.etiketInd },
          { id: 'hold', sek: Number(this.dataset.hold) || 0, etiket: this.dataset.etiketHold },
          { id: 'ud', sek: Number(this.dataset.ud) || 0, etiket: this.dataset.etiketUd },
          { id: 'holdud', sek: Number(this.dataset.holdud) || 0, etiket: this.dataset.etiketHoldud },
        ].filter((f) => f.sek > 0);

        this.knap.addEventListener('click', () => (this.#koerer ? this.#stop() : this.#start()));

        // En guide, der kører videre i en fane, ingen kigger på, er bare et
        // batteri der tømmes. Den stopper af sig selv og siger det.
        document.addEventListener('visibilitychange', () => {
          if (document.hidden && this.#koerer) this.#stop();
        });
      }

      disconnectedCallback() { this.#ryd(); }

      #ryd() {
        clearTimeout(this.#timer);
        clearInterval(this.#nedtaeller);
        this.#timer = null;
        this.#nedtaeller = null;
      }

      #start() {
        if (!this.faser.length) return;
        this.#koerer = true;
        this.knap.textContent = this.dataset.stop;
        this.knap.setAttribute('aria-pressed', 'true');
        this.#kør(0, 0);
      }

      #stop(afsluttet) {
        this.#ryd();
        this.#koerer = false;
        this.removeAttribute('data-fase');
        this.style.removeProperty('--fase-tid');
        this.knap.textContent = this.dataset.start;
        this.knap.setAttribute('aria-pressed', 'false');
        this.talEl.textContent = '';
        this.faseEl.textContent = afsluttet ? this.dataset.etiketSlut : this.dataset.etiketKlar;
        // Kun ved en færdig omgang: ellers ville et stop-tryk blive annonceret
        // som en præstation, kunden ikke har leveret.
        if (afsluttet) this.#sig(this.dataset.etiketSlut);
      }

      #kør(faseIndex, cyklus) {
        const maalCyklus = Number(this.dataset.cyklusser) || 1;
        if (cyklus >= maalCyklus) { this.#stop(true); return; }

        const f = this.faser[faseIndex];
        // Varigheden gives til CSS FØR fasen sættes, så overgangen starter med
        // den rigtige længde i stedet for den forrige fases.
        this.style.setProperty('--fase-tid', f.sek + 's');
        this.setAttribute('data-fase', f.id);
        this.faseEl.textContent = f.etiket;
        this.#sig(f.etiket);

        let tilbage = f.sek;
        this.talEl.textContent = String(tilbage);
        clearInterval(this.#nedtaeller);
        this.#nedtaeller = setInterval(() => {
          tilbage -= 1;
          this.talEl.textContent = String(Math.max(0, tilbage));
        }, 1000);

        this.#timer = setTimeout(() => {
          const næste = (faseIndex + 1) % this.faser.length;
          this.#kør(næste, næste === 0 ? cyklus + 1 : cyklus);
        }, f.sek * 1000);
      }

      // Skærmlæsere: ryd først, så den samme fase annonceres igen ved næste
      // omgang i stedet for at blive sprunget over som "uændret".
      #sig(besked) {
        if (!this.liveEl) return;
        this.liveEl.textContent = '';
        requestAnimationFrame(() => { this.liveEl.textContent = besked; });
      }
    }

    customElements.define('mw-breath', MwBreath);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mw-cart-drawer"]) return;
  try {
    
  (() => {
    if (customElements.get('mw-cart-drawer')) return;

    // Locale-/market-sikre endpoints (MW-008): /da-dk/cart/add.js osv.
    const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const MSG = {
      addFail: 'Kunne ikke lægge varen i kurven. Prøv igen.',
      changeFail: 'Kurven kunne ikke opdateres. Prøv igen.',
      soldOut: 'Varen kunne ikke lægges i kurven — den er muligvis udsolgt.',
      network: 'Ingen forbindelse — prøv igen om lidt.',
      added: 'Lagt i kurven.',
      removed: 'Vare fjernet.',
      updated: 'Kurv opdateret.',
    };

    class MwCartDrawer extends HTMLElement {
      #trigger = null;
      #queue = Promise.resolve();
      #qtyTimers = new Map();
      #ac = null;
      #closing = false;

      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;
        this.sectionId = this.dataset.sectionId;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.#ac = new AbortController();
        const sig = { signal: this.#ac.signal };

        document.addEventListener('click', (e) => {
          const toggle = e.target.closest('[data-mw-cart-toggle]');
          if (toggle) {
            e.preventDefault();
            this.open(toggle);
          }
        }, sig);

        // Globalt intercept: alle "Læg i kurv"-formularer i temaet (progressive:
        // uden JS poster formen normalt til /cart)
        document.addEventListener('submit', (e) => {
          const form = e.target;
          if (!(form instanceof HTMLFormElement)) return;
          const action = form.getAttribute('action') || '';
          // Opt-in: kun temaets egne formularer (data-mw-cart-form) — app-formularer får lov at poste selv
          if (!action.includes('/cart/add') || !form.hasAttribute('data-mw-cart-form')) return;
          e.preventDefault();
          // Indsenderen skal med. Uden e.submitter finder #doAddFromForm
          // ALTID formularens første submit-knap — og den sticky bars knap
          // står uden for formularen via form=-attributten. På mobil fik den
          // knap, kunden faktisk trykkede på, hverken ventetilstand eller
          // fokus tilbage; fokus landede på en knap langt uden for skærmen.
          this.addFromForm(form, e.submitter);
        }, sig);

        // Semantisk intent-kontrakt (§4.3): andre komponenter sender hensigter,
        // rører aldrig DOM eller cart-endpoints selv.
        document.addEventListener('mw:cart:add', (e) => {
          const d = e.detail || {};
          this.#enqueue(() => this.addItems(d.items || [{ id: d.id, quantity: d.quantity || 1, properties: d.properties }], d.open !== false));
        }, sig);
        document.addEventListener('mw:cart:change', (e) => {
          const d = e.detail || {};
          this.#cancelTimer(d.key);
          this.#enqueue(() => this.changeKey(d.key, d.quantity));
        }, sig);
        document.addEventListener('mw:cart:open', (e) => this.open(e.target), sig);
        document.addEventListener('mw:cart:close', () => this.close(), sig);

        // bfcache: vis aldrig en forældet kurv efter tilbage-navigation
        window.addEventListener('pageshow', (e) => { if (e.persisted) this.#enqueue(() => this.resync()); }, sig);

        this.dialog.addEventListener('click', (e) => {
          if (e.target.closest('[data-mw-cd-close], [data-mw-cd-close-link]')) {
            if (e.target.closest('[data-mw-cd-close]')) e.preventDefault();
            this.close();
            return;
          }
          if (e.target === this.dialog) this.close();

          const item = e.target.closest('.mw-cd__item');
          if (item) {
            const key = item.dataset.lineKey;
            const q = item.querySelector('[data-mw-cd-qty]');
            if (e.target.closest('[data-mw-cd-remove]')) {
              this.#cancelTimer(key); // MW-010: ingen forældet +-mutation efter fjern
              return this.#enqueue(() => this.changeKey(key, 0, this.#linePayload(item)));
            }
            if (e.target.closest('[data-mw-cd-minus]')) return this.bumpQty(key, q, Math.max(0, Number(q.value) - 1), item);
            if (e.target.closest('[data-mw-cd-plus]')) return this.bumpQty(key, q, Number(q.value) + 1, item);
            // Tilbuddet bruger den samme vej som plus-knappen: samme
            // debounce, samme lagerloft, samme ventetilstand. Ingen genvej,
            // der kan komme ud af trit med resten.
            const tilbud = e.target.closest('[data-mw-cd-offer]');
            if (tilbud) return this.bumpQty(key, q, Number(tilbud.dataset.mwCdOffer) || Number(q.value) + 1, item);
          }

          const up = e.target.closest('[data-mw-cd-upsell]');
          if (up) this.#enqueue(() => this.addItems([{ id: Number(up.dataset.variantId), quantity: 1 }], false));
        }, sig);

        this.dialog.addEventListener('change', (e) => {
          const q = e.target.closest('[data-mw-cd-qty]');
          if (!q) return;
          const key = q.closest('.mw-cd__item').dataset.lineKey;
          this.#cancelTimer(key); // MW-010: manuel indtastning vinder over ventende bump
          this.#enqueue(() => this.changeKey(key, Math.max(0, Number(q.value) || 0)));
        }, sig);

        this.dialog.addEventListener('cancel', (e) => {
          e.preventDefault();
          this.close();
        }, sig);
        // Robust fallback: enkelte WebViews sender ikke dialogens native
        // `cancel`-event, selv om Escape rammer et fokuseret element i dialogen.
        this.dialog.addEventListener('keydown', (e) => {
          if (e.key !== 'Escape') return;
          e.preventDefault();
          this.close();
        }, sig);

        this.#loadRecs();
      }

      disconnectedCallback() {
        this.#ac?.abort();
        this.#ac = null;
        this._recsAc?.abort();
        this.#qtyTimers.forEach((t) => clearTimeout(t.timer));
        this.#qtyTimers.clear();
        if (this.dialog && this.dialog.open) {
          this.dialog.close();
          window.mwScrollLock?.off();
        }
      }

      open(trigger) {
        if (this.dialog.open) return;
        this.#closing = false;
        this.#trigger = trigger && trigger.focus ? trigger : document.activeElement;
        this.dialog.showModal();
        window.mwScrollLock?.on(); // fælles iOS-sikker lås (ejes af mw-drawer)
        void this.dialog.offsetWidth;
        this.dialog.classList.add('is-open');
        const first = this.dialog.querySelector('[data-mw-cd-close]');
        if (first) first.focus();
      }

      close() {
        if (!this.dialog.open || this.#closing) return;
        this.#closing = true;
        const finish = () => {
          // Early exit (allerede lukket / race) må stadig slippe #closing og
          // scroll-låsen — ellers låser body for evigt efter et afbrudt close.
          if (!this.dialog.open) {
            this.#closing = false;
            window.mwScrollLock?.off();
            return;
          }
          this.dialog.close();
          this.#closing = false;
          window.mwScrollLock?.off();
          this.#restoreFocus();
        };
        if (this.reduced.matches) {
          this.dialog.classList.remove('is-open');
          finish();
          return;
        }
        // transitionend kan udeblive (baggrundsfane, afbrudt transition) —
        // fallback garanterer at dialogen altid lukker.
        let fallback;
        const done = (e) => {
          if (e && e.target !== this.dialog) return;
          clearTimeout(fallback);
          this.dialog.removeEventListener('transitionend', done);
          finish();
        };
        this.dialog.addEventListener('transitionend', done);
        fallback = setTimeout(done, 600);
        this.dialog.classList.remove('is-open');
      }

      #restoreFocus() {
        if (this.#trigger && document.contains(this.#trigger)) this.#trigger.focus();
        this.#trigger = null;
      }

      // Én FIFO-kø for alle mutationer: serialiseret → svar kommer i rækkefølge,
      // det seneste renderer sidst. Abort aldrig en igangværende mutation.
      #enqueue(job) {
        this.#queue = this.#queue.then(job).catch(() => {});
        return this.#queue;
      }

      #cancelTimer(key) {
        const t = this.#qtyTimers.get(key);
        if (t) clearTimeout(t.timer);
        this.#qtyTimers.delete(key);
      }

      // Hele linjens payload (til Fortryd efter fjern) — fra serverens render
      #linePayload(item) {
        const d = item.dataset;
        let properties;
        try { properties = d.properties ? JSON.parse(d.properties) : undefined; } catch (err) { properties = undefined; }
        return { id: Number(d.variantId), quantity: Number(d.quantity) || 1, properties, selling_plan: d.sellingPlan ? Number(d.sellingPlan) : undefined, title: d.title };
      }

      // Coalesce hurtige +/−-klik: optimistisk input nu, ét change-kald efter ro.
      // VENTETID FREM FOR GÆTVÆRK.
      //
      // Første forsøg regnede totalen ud lokalt: enhedspris gange antal.
      // Det virker kun i en butik uden mængderabat, og denne har en. Målt:
      //
      //   1 stk  enhed 189,00  linje 189,00  rabatter 0
      //   2 stk  enhed 160,65  linje 321,30  rabatter 1
      //
      // Ved to stykker ville udregningen have vist 378,00 mod sandhedens
      // 321,30 — 57 kroner forkert, i kundens disfavør, på pengevejen. Et
      // tal der blinker forkert og derefter retter sig ned, koster mere
      // tillid end et halvt sekunds ventetid.
      //
      // Problemet var heller aldrig ventetiden. Det var, at antallet
      // ændrede sig med det samme, mens totalen stod stille og så FORÆLDET
      // ud — to tal om samme kurv, der var uenige, uden at noget fortalte
      // hvorfor. Nu siger de det selv.
      #venter(paa) {
        for (const sel of ['[data-mw-cd-total]', '.mw-shipbar', '[data-mw-cd-lineprice]']) {
          for (const el of this.querySelectorAll(sel)) {
            el.classList.toggle('is-beregner', paa);
            if (paa) el.setAttribute('aria-busy', 'true');
            else el.removeAttribute('aria-busy');
          }
        }
      }

      bumpQty(key, input, value, item) {
        if (!key) return;
        // Fjern-knappen gav Fortryd; minus-knappen gjorde ikke, selv om den
        // sletter linjen lige så endeligt når man går fra 1 til 0. Samme
        // handling, to forskellige oplevelser. Nøglen er at fange linjens
        // data FØR draweren renderer sig selv om — bagefter findes den ikke.
        const genskab = value === 0 && item ? this.#linePayload(item) : undefined;
        // Lager-loft fra egne data (policy=deny): cap client-side, intet serverkald
        const max = item && item.dataset.inventoryMax ? Number(item.dataset.inventoryMax) : null;
        if (max !== null && value > max) {
          value = Math.max(0, max);
          this.fail('Kun ' + max + ' stk. på lager.');
          if (Number(input.value) === value) return;
        }
        input.value = value;
        this.#venter(true);
        this.#cancelTimer(key);
        const timer = setTimeout(() => {
          this.#qtyTimers.delete(key);
          this.#enqueue(() => this.changeKey(key, value, genskab));
        }, 280);
        this.#qtyTimers.set(key, { timer, value });
      }

      announce(message) {
        // Åben dialog → den indre region (den ydre er inert); lukket → den ydre (annonceres på siden)
        const live = this.dialog && this.dialog.open ? this.querySelector('[data-mw-cd-live-in]') : this.querySelector('[data-mw-cd-live]');
        if (!live) return;
        live.textContent = '';
        setTimeout(() => { live.textContent = message; }, 0);
      }

      // Fortryd-række i draweren (toasten udenfor er inert, mens dialogen er åben)
      showUndo(label, onUndo) {
        const row = this.querySelector('[data-mw-cd-undo]');
        const txt = this.querySelector('[data-mw-cd-undotext]');
        const btn = this.querySelector('[data-mw-cd-undobtn]');
        if (!row || !txt || !btn) return false;
        clearTimeout(this._undoTimer);
        txt.textContent = label;
        row.hidden = false;

        // Rækken skjuler sig selv på tre måder — timeout, klik og ny
        // handling — og alle tre skal rydde op ens. Før skjulte timeout'en
        // bare rækken, og stod fokus på Fortryd-knappen, faldt det til
        // <body>: tastaturbrugeren mistede sin plads i kurven efter otte
        // sekunder, uden at have gjort noget.
        const ryd = () => {
          row.hidden = true;
          btn.onclick = null;
          if (row.contains(document.activeElement)) {
            this.querySelector('[data-mw-cd-close]')?.focus({ preventScroll: true });
          }
        };

        btn.onclick = () => { ryd(); onUndo(); };

        // Intet automatisk fokustyveri. Annonceringen fortæller at rækken
        // findes; at rive fokus ud af en igangværende oprydning er lige så
        // forstyrrende som at tabe det bagefter.
        this.announce(label + '. Fortryd med knappen.');
        this._undoTimer = setTimeout(ryd, 8000);
        return true;
      }

      // Fejl skal ses og høres — også når draweren er lukket (MW-011)
      fail(message) {
        if (typeof window.mwToast === 'function') window.mwToast(message, { tone: 'error' });
        else this.announce(message);
        document.dispatchEvent(new CustomEvent('mw:cart:error', { detail: { message } }));
      }

      setBusy(state) {
        const panel = this.querySelector('[data-mw-cd-content]');
        if (panel) panel.setAttribute('aria-busy', state ? 'true' : 'false');
        document.dispatchEvent(new CustomEvent(state ? 'mw:cart:busy' : 'mw:cart:idle'));
      }

      // Central mutations-funktion (MW-009): sikker JSON-parse, 429-retry med
      // Retry-After, og re-sync ved tvetydige fejl (Shopify kan have muteret
      // kurven selv om section-renderingen fejlede med 400).
      async #mutate(path, init, retried) {
        let res;
        const opts = Object.assign({}, init, { signal: this.#ac?.signal });
        try {
          res = await fetch(root() + path, opts);
        } catch (err) {
          if (err.name === 'AbortError') return { ok: false, kind: 'abort' };
          await this.resync();
          return { ok: false, kind: 'network' };
        }
        if (res.status === 429 && !retried) {
          const wait = Math.min(3000, (Number(res.headers.get('Retry-After')) || 1) * 1000);
          await new Promise((r) => setTimeout(r, wait));
          return this.#mutate(path, init, true);
        }
        let json = null;
        try { json = await res.json(); } catch (err) { json = null; }
        if (!res.ok) {
          await this.resync();
          return { ok: false, kind: res.status === 422 ? 'unprocessable' : 'http', status: res.status, json };
        }
        return { ok: true, json };
      }

      // Re-render fra serveren uden mutation — sandheden efter enhver tvivl
      async resync() {
        const seq = (this._syncSeq = (this._syncSeq || 0) + 1);
        try {
          const res = await fetch(root() + '?sections=' + encodeURIComponent(this.sectionId), {
            headers: { Accept: 'application/json' },
            signal: this.#ac?.signal,
          });
          if (!res.ok || seq !== this._syncSeq) return;
          const sections = await res.json();
          if (seq !== this._syncSeq) return;
          this.renderSections(sections);
        } catch (err) {
          if (err.name === 'AbortError') return;
          /* stille — næste handling re-syncer igen */
        }
      }

      addFromForm(form, submitter) {
        return this.#enqueue(() => this.#doAddFromForm(form, submitter));
      }

      async #doAddFromForm(form, submitter) {
        const submitBtn = submitter || form.querySelector('[type="submit"], button:not([type])');
        if (submitBtn) submitBtn.setAttribute('aria-busy', 'true');
        try {
          const body = new FormData(form);
          body.append('sections', this.sectionId);
          body.append('sections_url', window.location.pathname);
          const r = await this.#mutate('cart/add.js', { method: 'POST', body, headers: { Accept: 'application/json' } });
          if (!r.ok) return this.fail(r.kind === 'network' ? MSG.network : r.kind === 'unprocessable' ? MSG.soldOut : MSG.addFail);
          this.renderSections(r.json.sections);
          this.announce(MSG.added);
          this.open(submitBtn || form);
        } finally {
          if (submitBtn) submitBtn.removeAttribute('aria-busy');
        }
      }

      // Flere items i ét kald (bundles/konfigurator) — aldrig variant-gæt her:
      // afsenderen har ansvaret for at items er eksplicit valgt (MW-003).
      async addItems(items, openAfter) {
        const clean = (items || []).filter((i) => i && i.id).map((i) => {
          const it = { id: Number(i.id), quantity: Number(i.quantity) || 1 };
          if (i.properties) it.properties = i.properties;
          if (i.selling_plan) it.selling_plan = i.selling_plan;
          return it;
        });
        if (!clean.length) return;
        this.setBusy(true);
        try {
          const r = await this.#mutate('cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: clean, sections: this.sectionId, sections_url: window.location.pathname }),
          });
          if (!r.ok) return this.fail(r.kind === 'network' ? MSG.network : r.kind === 'unprocessable' ? MSG.soldOut : MSG.addFail);
          this.renderSections(r.json.sections);
          this.announce(MSG.added);
          if (openAfter) this.open();
        } finally {
          this.setBusy(false);
        }
      }

      addVariant(variantId, quantity) {
        return this.addItems([{ id: variantId, quantity }], false);
      }

      async changeKey(key, quantity, undoPayload) {
        if (!key) return;
        this.setBusy(true);
        try {
          const r = await this.#mutate('cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: key, quantity, sections: this.sectionId, sections_url: window.location.pathname }),
          });
          if (!r.ok) return this.fail(r.kind === 'network' ? MSG.network : r.kind === 'unprocessable' ? MSG.soldOut : MSG.changeFail);
          this.renderSections(r.json.sections);
          // Stille lager-clamp: serveren kan returnere lavere antal end bedt om
          const line = Array.isArray(r.json.items) ? r.json.items.find((i) => i.key === key) : null;
          if (quantity > 0 && line && line.quantity < quantity) {
            this.fail('Kun ' + line.quantity + ' stk. på lager.');
            return;
          }
          if (quantity === 0 && undoPayload) {
            // Undo (P0.4): hele payloaden gen-addes; merger hvis linjen findes igen.
            // Åben drawer → inline-række (toasten udenfor er inert); lukket → toast.
            const label = undoPayload.title ? undoPayload.title + ' fjernet fra kurven' : MSG.removed;
            const payload = { id: undoPayload.id, quantity: undoPayload.quantity, properties: undoPayload.properties, selling_plan: undoPayload.selling_plan };
            const undo = () => this.#enqueue(() => this.addItems([payload], false));
            const inline = this.dialog && this.dialog.open && this.showUndo(label, undo);
            if (!inline && typeof window.mwToast === 'function') window.mwToast(label, { action: { label: 'Fortryd', onClick: undo } });
            else if (!inline) this.announce(label);
          } else {
            this.announce(quantity === 0 ? MSG.removed : MSG.updated);
          }
        } finally {
          this.setBusy(false);
        }
      }

      renderSections(sections) {
        // En fejlet sektion er null i et 200-svar — swap aldrig destruktivt
        if (!sections || typeof sections[this.sectionId] !== 'string') return;

        // Hele indholdet skiftes ud på én gang, så en vare enten ER der eller
        // ER væk — uden overgang. En View Transition lader browseren finde ud
        // af forskellen selv: linjer der bliver, MORFER på plads (også når
        // antal og pris ændrer sig), nye toner ind, fjernede toner ud.
        //
        // Vi navngiver hver linje efter sin cart-key i #navngivLinjer, så
        // browseren kan parre gammel og ny. Uden navne ville hele panelet
        // krydsfade som ét billede, og så var vi lige vidt.
        const roligt = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (document.startViewTransition && !roligt && this.dialog.open) {
          this.#navngivLinjer();
          const vt = document.startViewTransition(() => this.#swapSections(sections));
          // Navnene ryddes bagefter: et view-transition-name skal være unikt i
          // hele dokumentet, og efterladte navne ville kollidere med næste swap.
          vt.finished.finally(() => this.#ryddLinjenavne());
          return;
        }

        this.#swapSections(sections);
      }

      #navngivLinjer() {
        // Kurvens line-key indeholder kolon (fx «41234:9ab…»), og et
        // view-transition-name SKAL være et gyldigt custom-ident. Browseren
        // afviser hele erklæringen tavst, hvis den ikke er det — og så
        // krydsfader panelet som ét billede i stedet for at morfe pr. linje.
        // Målt: navnene stod tomme i det øjeblik overgangen startede.
        for (const el of this.querySelectorAll('[data-line-key]')) {
          const id = String(el.dataset.lineKey || '').replace(/[^a-zA-Z0-9_-]/g, '-');
          if (id) el.style.viewTransitionName = 'mw-cdline-' + id;
        }
      }

      #ryddLinjenavne() {
        for (const el of this.querySelectorAll('[data-line-key]')) el.style.viewTransitionName = '';
      }

      #swapSections(sections) {

        let refocus = null;
        const active = document.activeElement;
        if (active && this.contains(active)) {
          const itemEl = active.closest('[data-line-key]');
          const attr = ['data-mw-cd-plus', 'data-mw-cd-minus', 'data-mw-cd-remove', 'data-mw-cd-qty'].find(
            (a) => active.closest('[' + a + ']')
          );
          if (itemEl && attr) {
            const all = Array.from(this.querySelectorAll('[data-line-key]'));
            refocus = { key: itemEl.dataset.lineKey, variant: itemEl.dataset.variantId, index: all.indexOf(itemEl), sel: '[' + attr + ']' };
          }
        }

        const doc = new DOMParser().parseFromString(sections[this.sectionId], 'text/html');
        const fresh = doc.querySelector('[data-mw-cd-content]');
        const current = this.querySelector('[data-mw-cd-content]');
        if (!fresh || !current) return;
        current.replaceWith(fresh);
        // Serverens tal er landet — ventetilstanden må slippe.
        this.#venter(false);
        // Den friske markup skal bære SAMME navne som den gamle, ellers har
        // browseren ingen at parre med, og alt læses som nyt.
        if (document.startViewTransition) this.#navngivLinjer();
        // Swappet HTML afspejler serveren — ventende bump-timere er forældede
        this.#qtyTimers.forEach((t) => clearTimeout(t.timer));
        this.#qtyTimers.clear();

        if (this.dialog.open && refocus) {
          // Linje-key'en skifter hash ved cart/change → fald tilbage til variant-id, så position
          const byKey = this.querySelector('[data-line-key="' + CSS.escape(refocus.key) + '"]');
          const byVar = refocus.variant ? this.querySelector('[data-line-key][data-variant-id="' + CSS.escape(refocus.variant) + '"]') : null;
          const all = Array.from(this.querySelectorAll('[data-line-key]'));
          const itemEl = byKey || byVar || all[Math.min(refocus.index, all.length - 1)] || null;
          const target = itemEl && itemEl.querySelector(refocus.sel);
          if (target) target.focus();
        }

        const countEl = this.querySelector('[data-mw-cd-count]');
        const count = countEl ? Number(countEl.dataset.count) : 0;
        document.querySelectorAll('[data-mw-cart-count]').forEach((el) => {
          el.textContent = count;
          el.hidden = count === 0;
        });
        // Synligt tal og tilgængeligt navn fra samme tilstand (MW-015)
        document.querySelectorAll('[data-mw-cart-toggle]').forEach((el) => {
          el.setAttribute('aria-label', 'Kurv, ' + count + ' ' + (count === 1 ? 'vare' : 'varer'));
        });

        if (this.dialog.open && (document.activeElement === document.body || !this.dialog.contains(document.activeElement))) {
          const closeBtn = this.querySelector('[data-mw-cd-close]');
          if (closeBtn) closeBtn.focus();
        }

        document.dispatchEvent(new CustomEvent('mw:cart:updated', { detail: { itemCount: count } }));
        this.#loadRecs();
      }

      // Automatiske anbefalinger (fallback uden kuraterede blokke). Native
      // Product Recommendations API renderet som Liquid-sektion — ingen
      // klient-templating. Forældede svar droppes via sekvensnummer.
      async #loadRecs() {
        const box = this.querySelector('[data-mw-cd-recs]');
        if (!box) return;
        const pid = box.dataset.productId;
        if (!pid) return;
        const seq = (this._recsSeq = (this._recsSeq || 0) + 1);
        this._recsAc?.abort();
        this._recsAc = new AbortController();
        const signal = this._recsAc.signal;
        try {
          const url = root() + 'recommendations/products?section_id=mw-cart-recs&product_id=' + encodeURIComponent(pid) + '&limit=6&intent=related';
          const res = await fetch(url, { headers: { Accept: 'text/html' }, signal });
          if (!res.ok || seq !== this._recsSeq) return;
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          if (seq !== this._recsSeq) return;
          const list = doc.querySelector('[data-mw-cd-recs-list]');
          const slot = this.querySelector('[data-mw-cd-recs-slot]');
          if (!list || !slot || !list.children.length) return;
          // Produkter der lukker fri fragt-gabet først; maks. 3 (kompakt)
          Array.from(list.children)
            .filter((li) => li.dataset.closesGap === 'true')
            .reverse()
            .forEach((li) => list.prepend(li));
          Array.from(list.children).slice(3).forEach((li) => li.remove());
          slot.replaceChildren(list);
          box.hidden = false;
        } catch (err) {
          if (err.name === 'AbortError') return;
          /* stille — upsell er aldrig kritisk */
        }
      }
    }

    customElements.define('mw-cart-drawer', MwCartDrawer);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mw-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('mw-collection')) return;

    class MwCollection extends HTMLElement {
      connectedCallback() {
        this._ac = new AbortController();
        const sig = { signal: this._ac.signal };
        this.results = this.querySelector('[data-mw-col-results]');
        this.form = this.querySelector('[data-mw-col-form]');
        this._seq = 0;

        // Filtre: ændring → hent (debounce for pris-felter)
        let deb = 0;
        this.form?.addEventListener('change', (e) => {
          clearTimeout(deb);
          const wait = e.target.type === 'number' ? 500 : 0;
          deb = setTimeout(() => this.#apply(), wait);
        }, sig);
        this.form?.addEventListener('submit', (e) => {
          e.preventDefault();
          this.#apply();
          this.querySelector('mw-drawer')?.close();
        }, sig);
        // Sortering (select bor i toolbaren men peger på formen via form=)
        this.addEventListener('change', (e) => {
          if (e.target.matches('[data-mw-col-sort]')) this.#apply();
        }, sig);
        // Chips / paginering / nulstil: intercept links → section fetch
        this.addEventListener('click', (e) => {
          const a = e.target.closest('[data-mw-col-link]');
          if (!a) return;
          e.preventDefault();
          this.#load(a.href, true);
          if (a.closest('.mw-col__pag')) {
            const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
            this.scrollIntoView({ behavior, block: 'start' });
          }
        }, sig);
        window.addEventListener('popstate', () => this.#load(window.location.href, false), sig);
      }

      disconnectedCallback() {
        this._ac?.abort();
        this._fetchAc?.abort();
      }

      #apply() {
        const params = new URLSearchParams();
        if (this.form) {
          new FormData(this.form).forEach((v, k) => { if (String(v).trim() !== '') params.append(k, v); });
        }
        const sort = this.querySelector('[data-mw-col-sort]');
        if (sort && sort.value) params.set('sort_by', sort.value);
        const url = this.dataset.url + (params.toString() ? '?' + params.toString() : '');
        this.#load(url, true);
      }

      async #load(href, push) {
        const seq = ++this._seq;
        this._fetchAc?.abort();
        this._fetchAc = new AbortController();
        const fetchSig = this._fetchAc.signal;
        const url = new URL(href, window.location.origin);
        url.searchParams.set('section_id', this.dataset.sectionId);
        this.results.setAttribute('aria-busy', 'true');
        try {
          const res = await fetch(url.toString(), { headers: { Accept: 'text/html' }, signal: fetchSig });
          if (!res.ok || seq !== this._seq) return;
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          const freshResults = doc.querySelector('[data-mw-col-results]');
          const freshFacets = doc.querySelector('[data-mw-col-facets]');
          const freshCount = doc.querySelector('[data-mw-col-applycount]');
          if (freshResults) this.results.replaceWith(freshResults);
          this.results = this.querySelector('[data-mw-col-results]');
          // Facetter: bevar fokus og åbne grupper
          const curFacets = this.querySelector('[data-mw-col-facets]');
          if (freshFacets && curFacets) {
            const focused = document.activeElement && curFacets.contains(document.activeElement) ? { name: document.activeElement.name, value: document.activeElement.value } : null;
            const openLabels = Array.from(curFacets.querySelectorAll('details[open] > summary > span:first-child')).map((s) => s.textContent);
            curFacets.replaceWith(freshFacets);
            freshFacets.querySelectorAll('details').forEach((d) => { const l = d.querySelector('summary > span:first-child')?.textContent; if (openLabels.includes(l)) d.open = true; });
            if (focused) freshFacets.querySelector('[name="' + CSS.escape(focused.name) + '"][value="' + CSS.escape(focused.value) + '"]')?.focus();
          }
          const applyCount = this.querySelector('[data-mw-col-applycount]');
          if (applyCount && freshCount) applyCount.textContent = freshCount.textContent;
          if (push) {
            url.searchParams.delete('section_id');
            window.history.pushState({}, '', url.toString());
          }
          // Fokus til resultaterne når brugeren ikke er i facet-drawer (tastatur/chips/paginering)
          const inFacets = document.activeElement && this.querySelector('mw-drawer')?.contains(document.activeElement);
          if (!inFacets && this.results) {
            this.results.setAttribute('tabindex', '-1');
            this.results.focus({ preventScroll: true });
          }
          // Annoncér resultatet i en region, der IKKE swappes (ny live region annonceres ikke)
          const live = this.querySelector('[data-mw-col-live]');
          const countEl = this.querySelector('[data-mw-col-count]');
          if (live) { live.textContent = ''; setTimeout(() => { live.textContent = countEl ? countEl.textContent.trim() : 'Resultater opdateret'; }, 0); }
          document.dispatchEvent(new CustomEvent('mw:collection:updated', { bubbles: true }));
        } catch (err) {
          if (err.name === 'AbortError') return;
          // Fald tilbage til fuld navigation — aldrig en død side
          if (typeof window.mwToast === 'function') window.mwToast('Kunne ikke opdatere listen — indlæser siden igen.', { tone: 'error' });
          window.location.assign(href);
        } finally {
          if (seq === this._seq) this.results?.setAttribute('aria-busy', 'false');
        }
      }
    }

    customElements.define('mw-collection', MwCollection);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mw-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('mw-hero-slider')) return;

    class MwHeroSlider extends HTMLElement {
      #timer = null;
      #index = 0;
      #userPaused = false;   // via rotationskontrollen
      #focusPaused = false;  // APG: tastaturfokus stopper rotation permanent
      #hovering = false;
      #ac = null;

      connectedCallback() {
        this.track = this.querySelector('[data-mw-hero-track]');
        this.slides = Array.from(this.querySelectorAll('[data-mw-hero-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-mw-hero-dot]'));
        this.pauseBtn = this.querySelector('[data-mw-hero-pause]');
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        if (!this.track || this.slides.length === 0) return;

        this.#ac = new AbortController();
        const sig = { signal: this.#ac.signal };

        this.interval = Number(this.dataset.interval) || 6000;
        this.autoplayWanted = this.dataset.autoplay === 'true' && !this.reduced.matches;

        // Reduced motion: ingen rotation OG ingen kontrol der lover den (MW-023)
        if (this.reduced.matches && this.pauseBtn) this.pauseBtn.hidden = true;

        this.#applyActive(0);

        // Pausen bindes FØR den tidlige exit. Med ét slide er der ingen
        // rotation at standse, men der kan sagtens være en video — og
        // knappen lovede at kunne standse den. Den var bare aldrig koblet.
        this.pauseBtn?.addEventListener('click', () => {
          const paused = this.#userPaused || this.#focusPaused;
          // Kun rotationskontrollen kan genoptage efter fokus-pause (MW-021)
          this.#userPaused = !paused;
          this.#focusPaused = false;
          // Kontrollen gælder alt der bevæger sig, ikke kun karrusellen.
          const v = this.slides[this.#index]?.querySelector('[data-mw-hero-video]');
          if (v) {
            if (this.#userPaused) v.pause();
            else v.play().catch(() => {});
          }
          this.#renderPauseState();
          this.#sync();
        }, sig);

        if (this.slides.length < 2) return;

        this.querySelector('[data-mw-hero-prev]')?.addEventListener('click', () => this.#step(-1, true), sig);
        this.querySelector('[data-mw-hero-next]')?.addEventListener('click', () => this.#step(1, true), sig);
        this.dots.forEach((d) =>
          d.addEventListener('click', () => this.goTo(Number(d.dataset.mwHeroDot), true), sig)
        );


        this.addEventListener('pointerenter', () => { this.#hovering = true; this.#sync(); }, sig);
        this.addEventListener('pointerleave', () => { this.#hovering = false; this.#sync(); }, sig);
        this.addEventListener('focusin', () => {
          if (!this.#focusPaused) { this.#focusPaused = true; this.#renderPauseState(); }
          this.#sync();
        }, sig);
        document.addEventListener('visibilitychange', () => this.#sync(), sig);

        // Swipe/scroll opdaterer aktiv-tilstanden
        let scrollDeb = 0;
        this.track.addEventListener('scroll', () => {
          clearTimeout(scrollDeb);
          scrollDeb = setTimeout(() => {
            const n = this.slides.length || 1;
            const i = Math.min(n - 1, Math.max(0, Math.round(this.track.scrollLeft / this.track.clientWidth)));
            if (i !== this.#index) this.#applyActive(i);
          }, 90);
        }, { passive: true, signal: this.#ac.signal });

        // Tema-editor: valgt slide rulles frem og rotation stoppes
        document.addEventListener('shopify:block:select', (e) => {
          if (!(e.target && this.contains(e.target))) return;
          const i = this.slides.indexOf(e.target.closest('[data-mw-hero-slide]'));
          if (i >= 0) {
            this.#userPaused = true;
            this.#renderPauseState();
            this.goTo(i, false);
          }
        }, sig);

        this.#sync();
      }

      disconnectedCallback() {
        clearInterval(this.#timer);
        this.#timer = null;
        this.#ac?.abort();
        this.#ac = null;
      }

      goTo(i, byUser) {
        const n = this.slides.length;
        const next = ((i % n) + n) % n;
        // Gør mål-slidet interaktivt før browseren forsøger at snap-scrolle.
        // Chromium kan ellers afvise scroll-targetet, mens slidet stadig er inert.
        this.#applyActive(next);
        requestAnimationFrame(() => this.track.scrollTo({
          left: next * this.track.clientWidth,
          behavior: this.reduced.matches ? 'auto' : 'smooth',
        }));
        if (byUser) this.#sync(); // nulstil interval efter manuel handling
      }

      #step(dir, byUser) {
        this.goTo(this.#index + dir, byUser);
      }

      #renderPauseState() {
        if (!this.pauseBtn) return;
        const paused = this.#userPaused || this.#focusPaused;
        this.pauseBtn.setAttribute('aria-label', paused ? 'Afspil slideshow' : 'Sæt slideshow på pause');
        this.pauseBtn.querySelector('[data-mw-hero-icon="pause"]').hidden = paused;
        this.pauseBtn.querySelector('[data-mw-hero-icon="play"]').hidden = !paused;
      }

      #applyActive(i) {
        const n = this.slides.length;
        if (!n) return;
        i = Math.min(n - 1, Math.max(0, i | 0));
        this.#index = i;
        this.slides.forEach((slide, j) => {
          const active = j === i;
          slide.toggleAttribute('inert', !active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');

          // Ankomsten var bundet til :first-child, så den fyrede én gang pr.
          // sidevisning og aldrig igen. Med autoplay hvert 8. sekund ser
          // kunden slide 2 lige så meget som slide 1 — og slide 2 landede
          // helt fladt. Den ene mekanik der får heroen til at føles dyr,
          // gjaldt altså under en fjerdedel af visningstiden.
          //
          // Klassen fjernes og sættes igen efter en tvungen reflow, ellers
          // ser browseren ingen ændring og genstarter ikke animationen.
          if (active) {
            slide.classList.remove('is-active');
            void slide.offsetWidth;
            slide.classList.add('is-active');
          } else {
            slide.classList.remove('is-active');
          }

          const video = slide.querySelector('[data-mw-hero-video]');
          if (video) {
            // Kun det aktive slides video kører — og aldrig under reduced motion (MW-024)
            if (active && !this.reduced.matches && !this.#userPaused && !this.#focusPaused) video.play().catch(() => {});
            else video.pause();
          }
        });

        // Naboens billede opgraderes, så det ikke først hentes i det øjeblik
        // det skal vises. LCP-billedet er allerede hjemme på det tidspunkt,
        // så der er ingen konkurrence om båndbredden.
        const naeste = this.slides[(i + 1) % this.slides.length];
        naeste?.querySelectorAll('img[loading="lazy"]').forEach((im) => { im.loading = 'eager'; });
        this.dots.forEach((d, j) => {
          if (j === i) d.setAttribute('aria-current', 'true');
          else d.removeAttribute('aria-current');
        });
        const tone = this.slides[i].dataset.tone === 'ink' ? 'ink' : 'bone';
        this.classList.toggle('mw-heroslider--ink', tone === 'ink');
        // Heroen ejer slide-tilstanden; headeren (transparent over hero)
        // lytter og følger tonen (MW-004). Semantisk event, ingen DOM-kobling.
        this.dispatchEvent(new CustomEvent('mw:hero:change', { bubbles: true, detail: { index: i, tone } }));
      }

      #shouldRun() {
        return (
          this.autoplayWanted &&
          !this.#userPaused &&
          !this.#focusPaused &&
          !this.#hovering &&
          !document.hidden
        );
      }

      #sync() {
        clearInterval(this.#timer);
        this.#timer = null;
        if (this.#shouldRun()) {
          this.#timer = setInterval(() => this.#step(1, false), this.interval);
        }
      }
    }

    customElements.define('mw-hero-slider', MwHeroSlider);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mw-product-recs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('mw-product-recs')) return;
    class MwProductRecs extends HTMLElement {
      connectedCallback() {
        this._ac = new AbortController();
        this.#load(this._ac.signal);
      }

      disconnectedCallback() {
        this._ac?.abort();
      }

      async #load(signal) {
        const pid = this.dataset.productId;
        const grid = this.querySelector('[data-mw-precs-grid]');
        if (grid && grid.querySelector('[data-mw-precs-empty]')) { this.hidden = true; return; }
        if (this.dataset.fetch !== 'true' || !pid || !grid || grid.children.length) return;
        try {
          const url = (this.dataset.url || '/recommendations/products') + '?section_id=' + encodeURIComponent(this.dataset.sectionId) + '&product_id=' + encodeURIComponent(pid) + '&limit=4&intent=related';
          const res = await fetch(url, { headers: { Accept: 'text/html' }, signal });
          if (!res.ok || signal.aborted || !this.isConnected) return;
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          if (signal.aborted || !this.isConnected) return;
          const fresh = doc.querySelector('[data-mw-precs-grid]');
          if (!fresh || !fresh.children.length) return;
          grid.replaceChildren(...fresh.children);
          const n = Math.min(fresh.children.length, 4);
          this.className = this.className.replace(/\bmw-precs--n\d+\b/g, '').trim() + ' mw-precs--n' + n;
          this.dataset.count = String(n);
          this.hidden = false;
        } catch (err) {
          if (err.name === 'AbortError') return;
        }
      }
    }
    customElements.define('mw-product-recs', MwProductRecs);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mw-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('mw-product')) return;

    // Én prissandhed: butikkens money-format (window.mwMoney, theme.liquid) — samme som Liquid `| money`
    const money = (cents) => {
      if (window.mwMoney) return window.mwMoney(cents);
      const cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'DKK';
      try { return new Intl.NumberFormat('da-DK', { style: 'currency', currency: cur }).format(cents / 100); }
      catch (err) { return (cents / 100).toFixed(2).replace('.', ',') + ' kr.'; }
    };

    class MwProduct extends HTMLElement {
      connectedCallback() {
        this._ac = new AbortController();
        const sig = { signal: this._ac.signal };
        this.form = this.querySelector('[data-mw-pdp-form]');
        this.select = this.querySelector('[data-mw-pdp-select]');
        this.options = this.querySelector('[data-mw-pdp-options]');
        this.selectWrap = this.querySelector('[data-mw-pdp-selectwrap]');
        try { this.variants = JSON.parse(this.querySelector('[data-mw-pdp-variants]').textContent); } catch (err) { this.variants = []; }
        this.colorIndex = Number(this.dataset.colorIndex ?? -1);

        // Chips overtager fra select (progressive enhancement)
        if (this.options && this.selectWrap) {
          this.selectWrap.hidden = true;
          this.options.hidden = false;
          this.addEventListener('change', (e) => {
            if (e.target.matches('[data-mw-pdp-option]')) this.#resolve(true);
          }, sig);
          this.#resolve(false);
        }

        // "Om produktet": rolig scroll + fokus til detaljerne
        this.querySelector('[data-mw-pdp-anchor]')?.addEventListener('click', (e) => {
          const target = this.querySelector('.mw-pdp__details');
          if (!target) return;
          e.preventDefault();
          target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
          target.focus({ preventScroll: true });
        }, sig);

        // Antal
        const qty = this.querySelector('[data-mw-pdp-qtyinput]');
        this.querySelector('[data-mw-pdp-minus]')?.addEventListener('click', () => { qty.value = Math.max(1, Number(qty.value) - 1); }, sig);
        // Tilbuddet SÆTTER antallet frem for kun at nævne det. Et tilbud, man
        // selv skal handle på, er halvt et tilbud — og at tælle op til to med
        // plus-knappen er to handlinger for noget, butikken lige har foreslået.
        this.querySelector('[data-mw-pdp-volume]')?.addEventListener('click', (ev) => {
          const maal = Number(ev.currentTarget.dataset.mwPdpVolume) || 2;
          const loft = Number(qty.getAttribute('max')) || Infinity;
          qty.value = String(Math.min(loft, maal));
          // Sig det højt: antallet ændrede sig et andet sted end dér, hvor
          // kunden trykkede.
          const live = this.querySelector('[data-mw-pdp-live]');
          if (live) live.textContent = 'Antal sat til ' + qty.value + '.';
          // Tilbuddet stod før oppe ved prisen og handlede på en købsblok
          // tusind pixels nede — antallet blev sat uden for skærmen, så for
          // en seende kunde skete der ingenting. Nu står de to ting ved
          // siden af hinanden, og ændringen ses, hvor den sker. Derfor
          // ingen scroll: fokus flytter sig et sted, kunden allerede kigger.
          this.querySelector('[data-mw-pdp-atc]')?.focus({ preventScroll: true });
        }, sig);

        this.querySelector('[data-mw-pdp-plus]')?.addEventListener('click', () => {
          // Loftet står som max på feltet, sat af Liquid og opdateret ved
          // variantskift. Uden Math.min ville knappen tælle forbi det tal,
          // formularen selv afviser.
          const loft = Number(qty.getAttribute('max')) || Infinity;
          qty.value = Math.min(loft, Math.max(1, Number(qty.value) + 1));
        }, sig);

        // Sticky mobil-bar: vis når primær ATC er rullet forbi
        const bar = this.querySelector('[data-mw-pdp-bar]');
        const atc = this.querySelector('[data-mw-pdp-atc]');
        if (bar && atc) {
          bar.hidden = false;
          const update = () => {
            const show = atc.getBoundingClientRect().bottom < 0;
            bar.classList.toggle('is-visible', show);
            bar.toggleAttribute('inert', !show);
            bar.setAttribute('aria-hidden', show ? 'false' : 'true');
            // Inbox-offset ejes globalt af mw-chat (data-mw-chat-avoid) — PDP'en skriver den aldrig selv
          };
          if ('IntersectionObserver' in window) {
            this._io = new IntersectionObserver(update, { threshold: 0 });
            this._io.observe(atc);
          }
          // Scroll-fallback (deterministisk, rAF-throttlet)
          let tick = false;
          window.addEventListener('scroll', () => {
            if (tick) return;
            tick = true;
            requestAnimationFrame(() => { tick = false; update(); });
          }, { passive: true, signal: this._ac.signal });
          update();
        }

        // ---- Galleri: thumbnail-rail + stage (desktop), snap-karrusel (mobil), lightbox ----
        const track = this.querySelector('[data-mw-pdp-track]');
        const counter = this.querySelector('[data-mw-pdp-counter]');
        this.slides = track ? Array.from(track.children) : [];
        this.thumbs = Array.from(this.querySelectorAll('[data-mw-pdp-thumb]'));
        this._gi = 0;
        const isMobile = () => window.matchMedia('(max-width: 989px)').matches;

        // Farve-filter: kun medier for den valgte farve (+ generiske) er synlige
        this.visibleIdx = () => this.slides.map((sl, j) => (sl.hidden ? -1 : j)).filter((j) => j >= 0);
        this.filterByColor = (color) => {
          const c = (color || '').toLowerCase();
          this.slides.forEach((sl, j) => {
            const cols = (sl.dataset.colors || '').split(',').filter(Boolean);
            const show = !c || cols.length === 0 || cols.includes(c);
            sl.hidden = !show;
            if (this.thumbs[j]) this.thumbs[j].hidden = !show;
          });
          // Intet synligt (alt-tekster uden match) → vis alt frem for et tomt galleri
          if (!this.visibleIdx().length) this.slides.forEach((sl, j) => { sl.hidden = false; if (this.thumbs[j]) this.thumbs[j].hidden = false; });
          this.relabel();
        };
        // Navnene kommer fra Liquid med ABSOLUTTE numre: «Vis billede 9 af 12».
        // Filtrerer JS så ned til 8 synlige, siger tælleren «6 / 8», mens den
        // sjette miniature stadig hedder «9 af 12». Målt på o2pro 2026-08-28:
        // 12 i DOM, 8 synlige. Den, der ser skærmen, mærker intet; den, der
        // lytter, får et tal, som hverken passer på rækken eller på tælleren.
        // Numrene hører til det, der faktisk står der.
        this.relabel = () => {
          const vis = this.visibleIdx();
          const n = vis.length;
          vis.forEach((j, pos) => {
            const t = this.thumbs[j];
            if (t) t.setAttribute('aria-label', 'Vis billede ' + (pos + 1) + ' af ' + n);
            this.slides[j].setAttribute('aria-label', (pos + 1) + ' af ' + n);
          });
        };
        this.goToMedia = (i, scroll) => {
          const vis = this.visibleIdx();
          const n = vis.length;
          if (!n) return;
          // i er et absolut slide-index; navigér inden for de synlige
          let pos = vis.indexOf(i);
          if (pos < 0) {
            // spring i retningen: find nærmeste synlige efter/før i
            const dir = i >= (this._gi || 0) ? 1 : -1;
            let k = i;
            for (let step = 0; step < this.slides.length; step++) { k = ((k % this.slides.length) + this.slides.length) % this.slides.length; if (!this.slides[k].hidden) break; k += dir; }
            pos = vis.indexOf(k);
            if (pos < 0) pos = 0;
          }
          pos = ((pos % n) + n) % n;
          const next = vis[pos];
          this._gi = next;
          this.slides.forEach((sl, j) => {
            const active = j === next;
            sl.classList.toggle('is-active', active);
            sl.setAttribute('aria-hidden', active ? 'false' : 'true');
            sl.toggleAttribute('inert', !active);
            const v = sl.querySelector('video');
            if (v && !active) v.pause();
          });
          this.thumbs.forEach((t, j) => { if (j === next) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
          const th = this.thumbs[next];
          const behavior = (this._instant || window.matchMedia('(prefers-reduced-motion: reduce)').matches) ? 'auto' : 'smooth';
          if (th) th.scrollIntoView({ block: 'nearest', behavior });
          if (counter) counter.textContent = (pos + 1) + ' / ' + n;
          if (scroll && track && isMobile()) track.scrollTo({ left: pos * track.clientWidth, behavior });
        };
        // Første visning: galleriet starter på den valgte variants billede (ikke produktets generiske)
        if (this.options && this.selectWrap) { this._instant = true; this.#resolve(false); this._instant = false; }

        this.thumbs.forEach((t) => t.addEventListener('click', () => this.goToMedia(Number(t.dataset.mwPdpThumb), true), sig));
        const stepVis = (d) => { const vis = this.visibleIdx(); const n = vis.length; if (!n) return this._gi; const pos = vis.indexOf(this._gi); return vis[(((pos < 0 ? 0 : pos) + d) % n + n) % n]; };
        this.stepMedia = stepVis;
        this.querySelector('[data-mw-pdp-prev]')?.addEventListener('click', () => this.goToMedia(stepVis(-1), true), sig);
        this.querySelector('[data-mw-pdp-next]')?.addEventListener('click', () => this.goToMedia(stepVis(1), true), sig);
        this.querySelector('[data-mw-pdp-thumbprev]')?.addEventListener('click', () => this.goToMedia(stepVis(-1), true), sig);
        this.querySelector('[data-mw-pdp-thumbnext]')?.addEventListener('click', () => this.goToMedia(stepVis(1), true), sig);
        // Rail-pile kun når listen overflower
        const list = this.querySelector('[data-mw-pdp-thumblist]');
        const syncRail = () => {
          const overflow = list && list.scrollHeight > list.clientHeight + 4;
          this.querySelectorAll('[data-mw-pdp-thumbprev], [data-mw-pdp-thumbnext]').forEach((b) => { b.hidden = !overflow; });
        };
        syncRail();
        window.addEventListener('resize', syncRail, { passive: true, signal: this._ac.signal });

        // Tastatur på galleriet
        this.querySelector('[data-mw-pdp-gallery]')?.addEventListener('keydown', (e) => {
          if (e.target.closest && e.target.closest('video, input, select, textarea')) return;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); this.goToMedia(stepVis(1), true); }
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); this.goToMedia(stepVis(-1), true); }
        }, sig);

        // Mobil: swipe opdaterer aktiv + tæller
        if (track) {
          let deb = 0;
          track.addEventListener('scroll', () => {
            if (!isMobile()) return;
            clearTimeout(deb);
            deb = setTimeout(() => {
              const vis = this.visibleIdx();
              const i = vis[Math.max(0, Math.min(vis.length - 1, Math.round(track.scrollLeft / track.clientWidth)))];
              if (i !== undefined && i !== this._gi) this.goToMedia(i, false);
            }, 80);
          }, { passive: true, signal: this._ac.signal });
        }

        // Lightbox
        const lb = this.querySelector('[data-mw-pdp-lb]');
        const lbImg = this.querySelector('[data-mw-pdp-lbimg]');
        const lbCap = this.querySelector('[data-mw-pdp-lbcap]');
        let lbSeq = 0;
        const showLb = async (i) => {
          const sl = this.slides[((i % this.slides.length) + this.slides.length) % this.slides.length];
          const src = sl && sl.dataset.zoom;
          if (!src || !lb || !lbImg) return;
          const seq = ++lbSeq;
          const pre = new Image();
          pre.src = src;
          try { if (pre.decode) await pre.decode(); } catch (e) { /* netværk/decoding — vis alligevel */ }
          if (seq !== lbSeq) return;
          this._li = this.slides.indexOf(sl);
          this._lbReturn = document.activeElement instanceof HTMLElement ? document.activeElement : null;
          lbImg.src = src;
          lbImg.alt = sl.querySelector('img')?.alt || '';
          const sceneImg = sl.querySelector('.mw-pdp__img');
          const fn = (src.split('/').pop() || '').toLowerCase();
          const isPack = !!sceneImg?.classList.contains('mw-pdp__img--pack')
            || fn.includes('wbg') || fn.includes('_hvid') || fn.includes('packshot') || fn.includes('transparent');
          lbImg.classList.toggle('mw-pdp__lbimg--pack', isPack);
          if (lbCap) lbCap.textContent = (this._li + 1) + ' / ' + this.slides.length;
          if (lb.open) return;

          // ZOOMEN MORFER. Lightboxen snappede frem uden overgang — i netop
          // det øjeblik, hvor galleriet skal vise sit værd. Nu vokser scenens
          // billede op til fuld skærm og lægger sig tilbage igen ved luk.
          //
          // Navnet flyttes UNDERVEJS, ikke sættes to steder: to elementer med
          // samme view-transition-name i samme tilstand får browseren til at
          // springe hele overgangen over. Scenens billede bærer det i den
          // gamle tilstand, lightboxens i den nye.
          const scene = sl.querySelector('.mw-pdp__img');
          const roligt = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          const aabn = () => { lb.showModal(); window.mwScrollLock?.on(); };

          if (!document.startViewTransition || roligt || !scene) return aabn();

          scene.style.viewTransitionName = '--mw-zoom';
          const vt = document.startViewTransition(() => {
            scene.style.viewTransitionName = '';
            lbImg.style.viewTransitionName = '--mw-zoom';
            aabn();
          });
          vt.finished.finally(() => { lbImg.style.viewTransitionName = ''; });
        };

        const closeLb = () => {
          if (!lb.open) {
            window.mwScrollLock?.off();
            return;
          }

          const luk = () => { lb.close(); window.mwScrollLock?.off(); };
          const sl = this.slides[this._li];
          const scene = sl && sl.querySelector('.mw-pdp__img');
          const roligt = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          if (!document.startViewTransition || roligt || !scene) return luk();

          lbImg.style.viewTransitionName = '--mw-zoom';
          const vt = document.startViewTransition(() => {
            lbImg.style.viewTransitionName = '';
            scene.style.viewTransitionName = '--mw-zoom';
            luk();
          });
          vt.finished.finally(() => { scene.style.viewTransitionName = ''; });
        };
        if (lb) {
          this.querySelector('[data-mw-pdp-zoom]')?.addEventListener('click', () => showLb(this._gi), sig);
          track?.addEventListener('click', (e) => { if (e.target.closest('.mw-pdp__img')) showLb(this._gi); }, sig);
          this.querySelector('[data-mw-pdp-lbclose]')?.addEventListener('click', closeLb, sig);
          this.querySelector('[data-mw-pdp-lbprev]')?.addEventListener('click', () => showLb(this._li - 1), sig);
          this.querySelector('[data-mw-pdp-lbnext]')?.addEventListener('click', () => showLb(this._li + 1), sig);
          lb.addEventListener('click', (e) => { if (e.target === lb) closeLb(); }, sig);
          lb.addEventListener('cancel', (e) => { e.preventDefault(); closeLb(); }, sig);
          lb.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') { e.preventDefault(); closeLb(); }
            if (e.key === 'ArrowRight') showLb(this._li + 1);
            if (e.key === 'ArrowLeft') showLb(this._li - 1);
          }, sig);
          lb.addEventListener('close', () => {
            window.mwScrollLock?.off();
            this.goToMedia(this._li, true);
            this._lbReturn?.focus({ preventScroll: true });
          }, sig);
        }
      }

      disconnectedCallback() {
        this._ac?.abort();
        this._io?.disconnect();
      }

      #chosen() {
        return Array.from(this.options.querySelectorAll('fieldset')).map((g) => { const c = g.querySelector('input:checked'); return c ? c.value : null; });
      }

      #resolve(byUser) {
        const chosen = this.#chosen();
        const match = this.variants.find((v) => v.options.every((o, i) => o === chosen[i]));
        // Marker utilgængelige valg pr. gruppe givet de øvrige valg
        this.options.querySelectorAll('fieldset').forEach((g, gi) => {
          g.querySelectorAll('input[type="radio"]').forEach((inp) => {
            const probe = chosen.slice(); probe[gi] = inp.value;
            const ok = this.variants.some((v) => v.available && v.options.every((o, i) => probe[i] === null || o === probe[i]));
            inp.nextElementSibling?.classList.toggle('is-unavailable', !ok);
          });
          const label = this.querySelector('[data-mw-pdp-chosen="' + gi + '"]');
          if (label) label.textContent = window.mwOptionLabel ? window.mwOptionLabel(chosen[gi] || '') : (chosen[gi] || '');
        });

        const atc = this.querySelector('[data-mw-pdp-atc]');
        const atcLabel = this.querySelector('[data-mw-pdp-atclabel]');
        const barAtc = this.querySelector('[data-mw-pdp-baratc]');
        const avail = this.querySelector('[data-mw-pdp-avail]');
        const cur = this.querySelector('[data-mw-pdp-current]');
        const cmp = this.querySelector('[data-mw-pdp-compare]');
        const barPrice = this.querySelector('[data-mw-pdp-barprice]');
        const live = this.querySelector('[data-mw-pdp-live]');

        if (!match) {
          atc.disabled = true; atcLabel.textContent = 'Ikke tilgængelig';
          if (barAtc) { barAtc.disabled = true; barAtc.textContent = 'Ikke tilgængelig'; }
          if (avail) avail.textContent = 'Denne kombination findes ikke.';
          if (byUser && live) live.textContent = 'Denne kombination findes ikke.';
          return;
        }
        this.select.value = String(match.id);

        // Loft og lagerlinje følger varianten. Uden det arver en variant med
        // to på lager loftet fra en variant med halvfems.
        const qtyFelt = this.querySelector('[data-mw-pdp-qtyinput]');
        if (qtyFelt) {
          const endeligt = match.inventory_management && match.inventory_policy === 'deny';
          if (endeligt) {
            qtyFelt.setAttribute('max', String(match.inventory_quantity));
            if (Number(qtyFelt.value) > match.inventory_quantity) {
              qtyFelt.value = String(Math.max(1, match.inventory_quantity));
            }
          } else {
            qtyFelt.removeAttribute('max');
          }
        }
        atc.disabled = !match.available;
        const atcOk = this.dataset.preorder === 'true' ? 'Forudbestil' : 'Læg i kurv';
        atcLabel.textContent = match.available ? atcOk : 'Udsolgt';
        if (barAtc) { barAtc.disabled = !match.available; barAtc.textContent = match.available ? atcOk : 'Udsolgt'; }
        // Forudbestillings-linjen er produktets, ikke variantens — den overskrives ikke.
        if (avail && !avail.hasAttribute('data-mw-preorder')) {
          avail.textContent = match.available ? 'På lager — sendes inden for ' + (this.dataset.shipping || '1–3 hverdage') : 'Midlertidigt udsolgt';
          avail.hidden = match.available && !!this.querySelector('[data-mw-deliv]');
        }
        if (cur) cur.textContent = money(match.price);
        if (barPrice) barPrice.textContent = money(match.price);
        const barVar = this.querySelector('[data-mw-pdp-barvariant]');
        if (barVar) barVar.textContent = window.mwOptionLabel ? window.mwOptionLabel(match.title) : match.title;
        if (cmp) {
          const onSale = match.compare_at_price && match.compare_at_price > match.price;
          cmp.hidden = !onSale;
          if (onSale) cmp.textContent = money(match.compare_at_price);
          // Besparelsen følger varianten. Samme 5 %-tærskel som Liquid'en,
          // ellers ville et variantskift kunne vise et mærkat, serveren
          // havde besluttet at skjule.
          const save = this.querySelector('[data-mw-pdp-save]');
          if (save) {
            const pct = onSale
              ? Math.round(((match.compare_at_price - match.price) / match.compare_at_price) * 100)
              : 0;
            save.hidden = pct < 5;
            if (pct >= 5) save.textContent = '\u2212' + pct + '\u00a0%';
          }
        }
        // Abonnementspriser følger varianten. Allocations ligger allerede i
        // variant-JSON'en, så der hentes intet og regnes intet ud her.
        const plans = this.querySelector('[data-mw-pdp-plans]');
        if (plans) {
          const once = plans.querySelector('[data-mw-pdp-planprice=""]');
          if (once) once.textContent = money(match.price);
          const allocs = match.selling_plan_allocations || [];
          let valgtBlevSkjult = false;
          for (const el of plans.querySelectorAll('[data-mw-pdp-planprice]')) {
            const id = el.getAttribute('data-mw-pdp-planprice');
            if (!id) continue;
            const raekke = el.closest('.mw-pdp__plan');
            const alloc = allocs.find((a) => String(a.selling_plan_id) === id);
            // En variant uden planen må ikke kunne vælges: skjul rækken frem for
            // at vise en pris, der ikke gælder ved kassen.
            if (!alloc) {
              if (raekke) {
                const inp = raekke.querySelector('.mw-pdp__planinput');
                if (inp && inp.checked) { inp.checked = false; valgtBlevSkjult = true; }
                raekke.hidden = true;
              }
              continue;
            }
            if (raekke) raekke.hidden = false;
            // Rabatten står som mærke ved siden af takten; en overstreget pris
            // her ville sige det samme igen og presse rækken i stykker.
            el.textContent = money(alloc.price);
            const maerke = raekke && raekke.querySelector('.mw-pdp__plansave');
            if (maerke) {
              const c = alloc.compare_at_price;
              if (c && c > alloc.price) {
                maerke.hidden = false;
                maerke.textContent = '\u2212' + Math.round((c - alloc.price) * 100 / c) + '\u00A0%';
              } else {
                maerke.hidden = true;
              }
            }
          }
          // Faldt valget bort, står kunden tilbage uden noget valgt — før
          // hende tilbage til engangskøb frem for at sende en tom værdi videre.
          if (valgtBlevSkjult && once) {
            const engangs = once.closest('.mw-pdp__plan').querySelector('.mw-pdp__planinput');
            if (engangs) engangs.checked = true;
          }
          plans.hidden = allocs.length === 0;
        }
        // URL-sync (kun ved brugerens valg) + galleri/sticky-bar til variantens billede (altid — én sandhed)
        if (byUser) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url);
        }
        {
          const barImg = this.querySelector('[data-mw-pdp-barimg]');
          const vSrc = match.featured_image && match.featured_image.src;
          if (barImg && vSrc && barImg.dataset.mwSrc !== vSrc) {
            barImg.dataset.mwSrc = vSrc;
            barImg.removeAttribute('srcset');
            barImg.src = vSrc + (vSrc.includes('?') ? '&' : '?') + 'width=120';
          }
          if (this.filterByColor) {
            const ci = this.colorIndex;
            this.filterByColor(ci >= 0 ? match.options[ci] : '');
            // Aktivt slide skjult af filteret → hop til variantens billede / første synlige
            const cur = this.slides && this.slides[this._gi];
            const fm = match.featured_media && match.featured_media.id ? this.querySelector('[data-media-id="' + match.featured_media.id + '"]') : null;
            if (fm && Number(fm.dataset.index) !== this._gi) this.goToMedia(Number(fm.dataset.index), true);
            else if (cur && cur.hidden) this.goToMedia(this.visibleIdx()[0] ?? 0, true);
          } else if (match.featured_media && match.featured_media.id) {
            const slide = this.querySelector('[data-media-id="' + match.featured_media.id + '"]');
            if (slide && this.goToMedia && Number(slide.dataset.index) !== this._gi) this.goToMedia(Number(slide.dataset.index), true);
          }
        }
        // Variantafhængig copy: {OptionName} → valgt værdi
        const optNames = Array.from(this.querySelectorAll('[data-mw-pdp-options] fieldset legend')).map((l) => l.firstChild.textContent.trim());
        this.querySelectorAll('[data-mw-pdp-tpl]').forEach((el) => {
          let t = el.dataset.mwPdpTpl;
          optNames.forEach((n, i) => { const ov = match.options[i] || ''; t = t.split('{' + n + '}').join(window.mwOptionLabel ? window.mwOptionLabel(ov) : ov); });
          el.textContent = t;
        });
        if (byUser && live) {
          live.textContent = match.title + '. ' + money(match.price) + ' ' + (match.available ? 'På lager.' : 'Udsolgt.');
        }
        this.dispatchEvent(new CustomEvent('mw:product:variant', { bubbles: true, detail: { variant: match } }));
      }
    }

    customElements.define('mw-product', MwProduct);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mw-refill"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('mw-refill')) return;

    const UGER_PR_MD = 30.44 / 7;

    class MwRefill extends HTMLElement {
      connectedCallback() {
        this.slider = this.querySelector('[data-mw-refill-slider]');
        this.vaerdi = this.querySelector('[data-mw-refill-vaerdi]');
        this.live = this.querySelector('[data-mw-refill-live]');
        this.kort = [...this.querySelectorAll('[data-mw-refill-kort]')];
        if (!this.slider || !this.kort.length) return;
        this.maal = Number(this.dataset.maalDage) || 90;
        this.slider.addEventListener('input', () => this.tegn(false));
        this.slider.addEventListener('change', () => this.tegn(true));
        this.tegn(false);
      }

      // Prisen formateres af butikkens eget format, ikke af en gætning på
      // komma og tusindtalsseparator.
      #kr(oere) {
        if (window.mwMoney) return window.mwMoney(Math.round(oere));
        return (Math.round(oere) / 100).toFixed(2).replace('.', ',') + ' kr';
      }

      // Én æske kan række alt fra en uge til godt et år. Enheden følger
      // størrelsen, så tallet altid er til at holde i hovedet: 18 dage,
      // 6 uger, 4 måneder — aldrig «0,6 måneder» eller «183 dage».
      #varighed(dage) {
        if (dage < 21) return Math.round(dage) + ' dage';
        if (dage < 84) return Math.round(dage / 7) + ' uger';
        const md = dage / 30.44;
        return (md < 3 ? Math.round(md * 2) / 2 : Math.round(md)).toString().replace('.', ',') + ' mdr.';
      }

      tegn(annoncer) {
        const n = Math.max(1, Number(this.slider.value) || 7);
        this.vaerdi.textContent = n + (n === 1 ? ' nat' : ' nætter');
        // Sporets gradient følger positionen — 1..7 på en 0..100-skala.
        this.slider.style.setProperty('--fyld', (((n - 1) / 6) * 100).toFixed(1) + '%');

        let bedste = null;
        let bedsteAfstand = Infinity;

        for (const k of this.kort) {
          const brug = Number(k.dataset.dage) || 0;
          const pris = Number(k.dataset.pris) || 0;
          if (!brug) continue;

          const kalenderDage = (brug / n) * 7;
          const prBrug = pris / brug;
          const prMd = prBrug * n * UGER_PR_MD;

          k.querySelector('[data-mw-refill-raekker]').textContent = 'Rækker ' + this.#varighed(kalenderDage);
          k.querySelector('[data-mw-refill-md]').textContent = this.#kr(prMd) + ' / md.';
          k.querySelector('[data-mw-refill-stk]').textContent = this.#kr(prBrug) + ' pr. gang';

          const afstand = Math.abs(kalenderDage - this.maal);
          if (afstand < bedsteAfstand) { bedsteAfstand = afstand; bedste = k; }
        }

        for (const k of this.kort) {
          const valgt = k === bedste;
          k.classList.toggle('er-anbefalet', valgt);
          const m = k.querySelector('[data-mw-refill-maerke]');
          if (m) m.hidden = !valgt;
        }

        // Kun ved slip, ikke ved hvert eneste trin — ellers taler
        // skærmlæseren i ét væk, mens fingeren stadig bevæger sig.
        if (annoncer && bedste && this.live) {
          const navn = bedste.querySelector('.mw-refill__pakke').textContent.trim();
          const raek = bedste.querySelector('[data-mw-refill-raekker]').textContent.trim();
          this.live.textContent = '';
          requestAnimationFrame(() => { this.live.textContent = navn + '. ' + raek + '.'; });
        }
      }
    }

    customElements.define('mw-refill', MwRefill);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mw-reviews"] && !Shopify.designMode) return;
  try {
    
  // Væggen viser de første N anmeldelser; resten er ét tryk væk. Knappen
  // er hidden i markup og tændes herfra, så siden uden JS viser alle kort
  // frem for en knap, der ikke virker.
  class MwRevwallMere extends HTMLElement {
    connectedCallback() {
      this.vis = parseInt(this.dataset.vis || '0', 10);
      this.kort = Array.from(this.querySelectorAll('.mw-revwall__kort'));
      this.knap = this.querySelector('[data-mw-rev-mere]');
      this.liste = this.querySelector('.mw-revwall__liste');
      if (!this.knap || this.vis < 1 || this.kort.length <= this.vis) return;
      if (this.liste && !this.liste.id) this.liste.id = 'MwRevwall-' + Math.random().toString(36).slice(2, 8);
      if (this.liste) this.knap.setAttribute('aria-controls', this.liste.id);
      this.knap.hidden = false;
      this.#foldSammen(false);
      this.knap.addEventListener('click', () => (this.aaben ? this.#foldSammen(true) : this.#foldUd()));
    }

    #foldSammen(flytFokus) {
      for (let i = 0; i < this.kort.length; i++) this.kort[i].hidden = i >= this.vis;
      this.aaben = false;
      this.knap.setAttribute('aria-expanded', 'false');
      this.knap.textContent = this.knap.dataset.mere;
      if (flytFokus) {
        const rolig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.knap.scrollIntoView({ block: 'center', behavior: rolig ? 'auto' : 'smooth' });
      }
    }

    #foldUd() {
      for (const k of this.kort) k.hidden = false;
      this.aaben = true;
      this.knap.setAttribute('aria-expanded', 'true');
      this.knap.textContent = this.knap.dataset.faerre;
    }
  }

  customElements.define('mw-revwall-mere', MwRevwallMere);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mw-social"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('mw-social-carousel')) return;

    const EASE = (t) => 1 - Math.pow(1 - t, 4);

    class MWSocialCarousel extends HTMLElement {
      connectedCallback() {
        this.scroller = this.querySelector('[data-mw-soc-scroller]');
        this.track = this.querySelector('[data-mw-soc-track]');
        this.prevBtn = this.querySelector('[data-mw-soc-prev]');
        this.nextBtn = this.querySelector('[data-mw-soc-next]');
        this.bar = this.querySelector('[data-mw-soc-bar]');
        this.thumb = this.querySelector('[data-mw-soc-thumb]');
        if (!this.scroller || !this.track) return;

        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this._raf = 0;
        this._suppressClick = false;
        this._ac = new AbortController();
        const sig = { signal: this._ac.signal };

        this.scroller.addEventListener('scroll', () => this.requestUpdate(), { passive: true, signal: this._ac.signal });
        this._ro = new ResizeObserver(() => this.requestUpdate());
        this._ro.observe(this.scroller);

        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.page(-1), sig);
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.page(1), sig);

        this.scroller.addEventListener('pointerdown', (e) => this.onDown(e), sig);
        this.addEventListener(
          'click',
          (e) => {
            if (this._suppressClick) {
              e.preventDefault();
              e.stopPropagation();
              this._suppressClick = false;
            }
          },
          { capture: true, signal: this._ac.signal }
        );
        this.addEventListener('dragstart', (e) => e.preventDefault(), sig);

        // Opslags-modal (GoPro-mønster)
        const modal = this.parentElement?.querySelector('[data-mw-soc-modal]');
        if (modal) {
          const mediaBox = modal.querySelector('[data-mw-soc-modalmedia]');
          const openPost = (btn) => {
            const d = btn.dataset;
            mediaBox.textContent = '';
            if (d.video) {
              const v = document.createElement('video');
              v.src = d.video; v.poster = d.image; v.controls = true; v.playsInline = true; v.muted = false;
              mediaBox.appendChild(v);
              if (!this.reduced.matches) v.play().catch(() => {});
            } else {
              const img = document.createElement('img');
              const alt = (d.caption || '').trim() || (d.account ? 'Opslag fra ' + d.account : 'Socialt opslag');
              img.src = d.image; img.alt = alt; img.width = 1200; img.height = 1200;
              mediaBox.appendChild(img);
            }
            const acct = d.account || '';
            modal.querySelector('[data-mw-soc-modalinitial]').textContent = (acct.replace('@', '')[0] || 'M').toUpperCase();
            modal.querySelector('[data-mw-soc-modalname]').textContent = acct.replace('@', '').split('.')[0].replace(/^\w/, (c) => c.toUpperCase());
            modal.querySelector('[data-mw-soc-modalacct]').textContent = acct;
            modal.querySelector('[data-mw-soc-modalcaption]').textContent = d.caption || '';
            modal.querySelector('[data-mw-soc-modaldate]').textContent = d.date || '';
            const link = modal.querySelector('[data-mw-soc-modallink]');
            if (d.permalink) { link.href = d.permalink; link.hidden = false; } else { link.hidden = true; }
            this._modalTrigger = btn;
            modal.showModal();
            window.mwScrollLock?.on();
            modal.querySelector('[data-mw-soc-close]').focus();
          };
          const closePost = () => {
            if (!modal.open) {
              window.mwScrollLock?.off();
              return;
            }
            mediaBox.querySelector('video')?.pause();
            modal.close();
            window.mwScrollLock?.off();
            if (this._modalTrigger && document.contains(this._modalTrigger)) this._modalTrigger.focus();
          };
          this.addEventListener('click', (e) => {
            const btn = e.target.closest('[data-mw-soc-post]');
            if (btn && !this._suppressClick) openPost(btn);
          }, sig);
          modal.querySelector('[data-mw-soc-close]').addEventListener('click', closePost, sig);
          modal.addEventListener('click', (e) => { if (e.target === modal) closePost(); }, sig);
          modal.addEventListener('cancel', (e) => { e.preventDefault(); closePost(); }, sig);
          modal.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') { e.preventDefault(); closePost(); }
          }, sig);
        }

        this.requestUpdate();
      }

      // Theme Editor re-render (MW-035): ingen observers, lyttere eller
      // animationer må overleve elementet.
      disconnectedCallback() {
        this._ac?.abort();
        this._ro?.disconnect();
        cancelAnimationFrame(this._raf);
        cancelAnimationFrame(this._updRaf);
        this._raf = 0;
        this._pending = false;
        if (this._moveH && this.scroller) {
          this.scroller.removeEventListener('pointermove', this._moveH);
          this.scroller.removeEventListener('pointerup', this._upH);
          this.scroller.removeEventListener('pointercancel', this._upH);
        }
      }

      get maxScroll() {
        return this.scroller.scrollWidth - this.scroller.clientWidth;
      }

      stride() {
        const c = this.track.children;
        if (c.length > 1) return c[1].offsetLeft - c[0].offsetLeft;
        return c[0] ? c[0].offsetWidth : this.scroller.clientWidth;
      }

      requestUpdate() {
        if (this._pending) return;
        this._pending = true;
        this._updRaf = requestAnimationFrame(() => {
          this._pending = false;
          if (this.isConnected) this.update();
        });
      }

      update() {
        const s = this.scroller;
        const max = this.maxScroll;
        const flat = max < 2;
        if (this.prevBtn) this.prevBtn.disabled = flat || s.scrollLeft <= 1;
        if (this.nextBtn) this.nextBtn.disabled = flat || s.scrollLeft >= max - 1;
        if (this.bar && this.thumb) {
          this.bar.hidden = flat;
          if (!flat) {
            const w = this.bar.clientWidth;
            const tw = Math.max(w * (s.clientWidth / s.scrollWidth), 32);
            const x = max ? (s.scrollLeft / max) * (w - tw) : 0;
            this.thumb.style.width = tw + 'px';
            this.thumb.style.transform = 'translateX(' + x + 'px)';
          }
        }
      }

      snapOff() {
        this.scroller.style.scrollSnapType = 'none';
      }

      snapOn() {
        this.scroller.style.scrollSnapType = '';
      }

      stopGlide() {
        cancelAnimationFrame(this._raf);
        this._raf = 0;
      }

      animateTo(target, dur) {
        this.stopGlide();
        target = Math.max(0, Math.min(this.maxScroll, target));
        if (this.reduced.matches || dur <= 0) {
          this.scroller.scrollLeft = target;
          this.snapOn();
          return;
        }
        this.snapOff();
        const from = this.scroller.scrollLeft;
        const delta = target - from;
        const t0 = performance.now();
        const step = (now) => {
          const p = Math.min(1, (now - t0) / dur);
          this.scroller.scrollLeft = from + delta * EASE(p);
          if (p < 1) {
            this._raf = requestAnimationFrame(step);
          } else {
            this._raf = 0;
            this.snapOn();
          }
        };
        this._raf = requestAnimationFrame(step);
      }

      nearest(pos) {
        const st = this.stride();
        return Math.max(0, Math.min(this.maxScroll, Math.round(pos / st) * st));
      }

      page(dir) {
        const st = this.stride();
        const first = this.track.firstElementChild;
        const padL = first ? first.offsetLeft : 0;
        const usable = Math.max(st, this.scroller.clientWidth - padL);
        const count = Math.max(1, Math.floor(usable / st));
        let target = this.nearest(this.scroller.scrollLeft + dir * count * st);
        if (target === this.nearest(this.scroller.scrollLeft)) {
          target = this.nearest(this.scroller.scrollLeft + dir * st);
        }
        this.animateTo(target, 620);
      }

      onDown(e) {
        if (e.pointerType === 'touch' || e.button > 0) return;
        this.stopGlide();
        this.snapOff();
        this._sx = e.clientX;
        this._sl = this.scroller.scrollLeft;
        this._dist = 0;
        this._vx = 0;
        this._lastX = e.clientX;
        this._lastT = performance.now();
        this._dragging = true;
        this.scroller.setPointerCapture(e.pointerId);
        this.classList.add('is-grabbing');
        this._moveH = (ev) => this.onMove(ev);
        this._upH = (ev) => this.onUp(ev);
        this.scroller.addEventListener('pointermove', this._moveH);
        this.scroller.addEventListener('pointerup', this._upH);
        this.scroller.addEventListener('pointercancel', this._upH);
      }

      onMove(e) {
        if (!this._dragging) return;
        const dx = e.clientX - this._sx;
        this._dist = Math.max(this._dist, Math.abs(dx));
        this.scroller.scrollLeft = this._sl - dx;
        const now = performance.now();
        const dt = now - this._lastT;
        if (dt > 0) {
          const v = (this._lastX - e.clientX) / dt;
          this._vx = 0.8 * v + 0.2 * this._vx;
          this._lastX = e.clientX;
          this._lastT = now;
        }
      }

      onUp() {
        if (!this._dragging) return;
        this._dragging = false;
        this.classList.remove('is-grabbing');
        this.scroller.removeEventListener('pointermove', this._moveH);
        this.scroller.removeEventListener('pointerup', this._upH);
        this.scroller.removeEventListener('pointercancel', this._upH);
        if (this._dist > 6) this._suppressClick = true;
        if (performance.now() - this._lastT > 80) this._vx = 0;
        const v = Math.max(-3, Math.min(3, this._vx));
        const target = this.nearest(this.scroller.scrollLeft + v * 250);
        const dist = Math.abs(target - this.scroller.scrollLeft);
        this.animateTo(target, Math.min(900, 320 + dist * 0.5));
        setTimeout(() => {
          this._suppressClick = false;
        }, 120);
      }
    }

    customElements.define('mw-social-carousel', MWSocialCarousel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mw-support-contact"] && !Shopify.designMode) return;
  try {
    
  // Fejlboks får fokus ved load (efter server-validering), så tastatur/skærmlæser lander på fejlen
  document.addEventListener('DOMContentLoaded', () => { const e = document.querySelector('[data-mw-con-errors]'); if (e) e.focus({ preventScroll: false }); });
  (() => {
    if (customElements.get('mw-contact-form')) return;

    class MwContactForm extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.topic = this.querySelector('[data-mw-con-topic]');
        this.orderWrap = this.querySelector('[data-mw-con-orderwrap]');
        this.orderInput = this.querySelector('[data-mw-con-order]');
        this.orderOpt = this.querySelector('[data-mw-con-orderopt]');
        this.hint = this.querySelector('[data-mw-con-hint]');
        this.response = this.querySelector('[data-mw-con-response]');
        if (!this.form || !this.topic) return;

        this._t0 = performance.now();

        // Gendan emne + ordrenummer efter server-side fejl-reload
        try {
          const saved = JSON.parse(sessionStorage.getItem('mw-contact') || 'null');
          if (saved) {
            if (saved.topic) this.topic.value = saved.topic;
            if (saved.order && this.orderInput) this.orderInput.value = saved.order;
          }
          sessionStorage.removeItem('mw-contact');
        } catch (e) {
          /* sessionStorage utilgængelig — baseline fortsætter */
        }

        this.topic.addEventListener('change', () => this.sync());
        this.sync();

        this.form.addEventListener('submit', (e) => {
          // Ekstra spam-lag oven på Shopifys hCaptcha: honeypot + kort minimum-tid
          const hp = this.querySelector('[data-mw-con-hp]');

          // Honeypot forbliver tavs — en bot skal ikke lære, hvad der afslørede den.
          if (hp && hp.value !== '') { e.preventDefault(); return; }

          // Tids-guarden må ALDRIG ramme et menneske uden svar. Før delte den
          // gren med honeypotten, så en kunde der skrev hurtigt fik sin besked
          // slugt uden et ord. Nu venter vi de manglende millisekunder af og
          // sender selv — guarden er passeret ved gensubmit.
          if (performance.now() - this._t0 < 600) {
            e.preventDefault();
            if (window.mwToast) window.mwToast('Et øjeblik — vi sender din besked nu.');
            setTimeout(() => this.form.requestSubmit(), 700);
            return;
          }
          try {
            sessionStorage.setItem(
              'mw-contact',
              JSON.stringify({ topic: this.topic.value, order: this.orderInput ? this.orderInput.value : '' })
            );
          } catch (err) {
            /* ignore */
          }
        });

        const success = this.querySelector('[data-mw-con-success]');
        if (success) success.focus();
      }

      sync() {
        const opt = this.topic.selectedOptions[0];
        if (!opt) return;
        const needsOrder = opt.dataset.needsOrder === 'true';
        if (this.orderWrap) {
          this.orderWrap.hidden = !needsOrder && this.orderInput.value === '';
        }
        if (this.orderInput) {
          this.orderInput.required = needsOrder;
          this.orderInput.setAttribute('aria-required', needsOrder ? 'true' : 'false');
        }
        if (this.orderOpt) this.orderOpt.hidden = needsOrder;
        if (this.hint) {
          this.hint.textContent = opt.dataset.hint || '';
          this.hint.hidden = !opt.dataset.hint;
        }
        if (this.response) {
          // Nulstil altid før override — ellers hænger forrige emnes svartid (MW-040)
          this.response.textContent = opt.dataset.response || this.response.dataset.mwConDefaultResponse || '';
        }
      }
    }

    customElements.define('mw-contact-form', MwContactForm);
  })();

  } catch(e) { console.error(e); }
})();
})();
